<script setup lang="ts">
import {useTemplateRef, defineProps, computed, defineEmits} from "vue";
import BaseModal from "@/components/modals/BaseModal.vue";
import {ICar} from "@/interfaces/ICar";

const props = defineProps<{
  cars: ICar[],
  car: number | null,
  signNumberFilter: string,
}>();

const emits = defineEmits(['setCarToggle', 'filter:signNumber']);

const select = computed({
  get() {
    return props.car;
  },
  set(value) {
    emits('setCarToggle', value);
  }
});

const modal = useTemplateRef('cars-modal');
</script>

<template>
  <BaseModal>
    <template v-slot:modal>
      <div ref="cars-modal" class="modal fade" id="selectCarModal" tabindex="-1" aria-labelledby="exampleModalLabel"
           aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                Выбор техники
              </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="w-100">
                Фильтр по гос. номеру
                <input :value="signNumberFilter" @input="e => emits('filter:signNumber', e)" type="text" class="form-control form-control-sm w-100">
              </label>
              <div v-for="(car, i) in props.cars" :key="i" class="form-check">
                <label class="form-check-label" :for="car.signNumber">
                  {{ car.brandName }} {{ car.signNumber ? car.signNumber : car.garageNumber }}
                </label>
                <input v-model="select" :value="car.id" class="form-check-input" type="radio" name="cars"
                       :id="car.signNumber">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Закрыть</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:action="{open}">
      <slot name="action" :open="() => open(modal)"></slot>
    </template>
  </BaseModal>
</template>
